<div class="flex flex-col h-full overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col overflow-y-auto">
      <!-- Sous-titre -->
      <p class="fg-gris-1 text-[16px] font-medium text-center shrink-0 pt-10 pb-10">
        {{ 'choose_meal_plan.subtitle' | translate }}
      </p>

      <!-- Chargement -->
      @if (isLoading()) {
      <div class="flex-1 flex items-center justify-center">
        <app-loader [size]="'w-8 h-8'" class="mx-auto my-[30px]" />
      </div>
      } @else if (!mealPlans().length) {
      <!-- Aucune formule -->
      <div class="flex-1 flex items-center justify-center">
        <p class="fg-gris-1 text-[16px]">{{ 'choose_meal_plan.empty' | translate }}</p>
      </div>
      } @else {
      <!-- Grille des formules -->
      <div class="grid grid-cols-2 gap-5 px-[30px] pb-[30px]">
        @for (mealPlan of mealPlans(); track mealPlan.admission_id) {
        <div class="bg-white rounded-[5px] h-[98px] flex items-center px-[30px] gap-5">
          <div class="flex-1 min-w-0 flex flex-col gap-1">
            <span class="fg-noir-2 text-[20px] font-semibold leading-tight truncate">
              {{ mealPlan.admission_name }}
            </span>
            <span class="fg-gris-1 text-[16px] truncate">{{ mealPlan.admission_name }}</span>
          </div>
          <span class="fg-noir-2 text-[20px] font-semibold shrink-0">
            {{ mealPlan.admission_price | formatPrice }}
          </span>
          <button type="button" (click)="selectMealPlan(mealPlan)"
            class="bg-vert-1 border border-gris-4 rounded-[5px] h-[58px] px-5 text-white text-[16px] font-semibold whitespace-nowrap shrink-0 cursor-pointer hover:brightness-95 transition-all">
            {{ 'common.select' | translate }}
          </button>
        </div>
        }
      </div>
      }
    </div>
  </main>
</div>